import React from "react";
import { Modal, Button } from "antd";

/**
 * MHMDA: Mandatory consent modal when backend returns consent_required (medical keywords + WA).
 * Use when 200 response has consent_required: true so the user sees the legal consent flow
 * instead of a broken or missing AI response.
 */
const HealthConsentModal = ({ open, onAccept, onCancel }) => (
  <Modal
    title="Consumer Health Data: Consent Required"
    open={open}
    onCancel={onCancel}
    footer={[
      <Button key="cancel" onClick={onCancel}>
        Cancel
      </Button>,
      <Button key="accept" type="primary" onClick={onAccept}>
        Accept
      </Button>,
    ]}
  >
    <p style={{ margin: 0 }}>
      It looks like you may be sharing health-related information. To process
      this under Washington State law, we need your explicit consent to our
      Consumer Health Data Privacy Policy.
    </p>
  </Modal>
);

export default HealthConsentModal;
